import { render } from "./PublicationCourse.vue.js?vue&type=template&id=028160ee!=!../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./PublicationCourse.vue?vue&type=template&id=028160ee"
import script from "./PublicationCourse.vue.js?vue&type=script&lang=js!=!../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./PublicationCourse.vue?vue&type=script&lang=js"
export * from "./PublicationCourse.vue.js?vue&type=script&lang=js!=!../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./PublicationCourse.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/Web/scripts/pages/publication/PublicationCourse.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "028160ee"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('028160ee', __exports__)) {
    api.reload('028160ee', __exports__)
  }
  
  module.hot.accept("./PublicationCourse.vue.js?vue&type=template&id=028160ee!=!../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./PublicationCourse.vue?vue&type=template&id=028160ee", () => {
    api.rerender('028160ee', render)
  })

}


export default __exports__